export default __webpack_public_path__ + "assets/9a7a7a970f191ce311cf965f1de77707.png";